export default __webpack_public_path__ + "static/media/home-bg1.aff7c3af.svg";